<template>
  <v-card
    class="mx-auto"
    color="transparent"
    elevation="0"
    :max-width="width"
    :max-height="height"
  >
    <v-carousel :continuous="false" height="100%" hide-delimiter-background show-arrows-on-hover>
      
      <template v-slot:prev="{ on, attrs }">
        <v-btn
          dark
          fab
          icon
          style="background-color: rgba(0, 0, 0, 0.2);"
          v-bind="attrs"
          v-on="on"
        ><v-icon large>mdi-chevron-left</v-icon></v-btn>
      </template>
      <template v-slot:next="{ on, attrs }">
        <v-btn
          fab
          icon
          style="background-color: rgba(0, 0, 0, 0.2);"
          v-bind="attrs"
          v-on="on"
        ><v-icon large>mdi-chevron-right</v-icon></v-btn>
      </template>

      <v-carousel-item
        v-for="pic in pics"
        :key="pic"
      >
        <v-img
          contain
          style="border-radius: 10px;"
          :src="pic"
          :max-height="height"
        />
      </v-carousel-item>
    </v-carousel>
  </v-card>
</template>

<script>
export default {
  props: {
    pics: {
      require: true,
      type: Array,
    },
    height: {
      default: 400,
      require: true,
      type: Number
    },
    width: {
      default: 700,
      require: true,
      type: Number
    },
  },
}
</script>